import React, { useState, useEffect } from "react";
import "./TimeTrackReporterForm.css"
import { API_ROUTE } from "../~api/apiRoutes";

const TimeTrackReporterForm = () => {

  const [serviceUrl, setServiceUrl] = useState("");
  const [serviceProtocol, setServiceProtocol] = useState("https");
  const [userEmail, setUserEmail] = useState("");
  const [apiToken, setApiToken] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [loading, setLoading] = useState(false);
  const [advancedModeEnabled, setAdvancedModeEnabled] = useState(false);
  const [projects, setProjects] = useState<string[]>([]);
  const [selectedProjects, setSelectedProjects] = useState<string[]>([]);
  const [selectedService, setSelectedService] = useState("gitlab-option");
  const [reportType, setReportType] = useState(0);
  
  useEffect(() => {
    const domainFromStorage = localStorage.getItem("serviceDomain");
    const apiTokenFromStorage = localStorage.getItem("apiToken");
    const userEmailFromStorage = localStorage.getItem("userEmail");
  
    if (domainFromStorage) setServiceUrl(domainFromStorage);
    if (apiTokenFromStorage) setApiToken(apiTokenFromStorage);
    if (userEmailFromStorage) setUserEmail(userEmailFromStorage);
  }, []);

  useEffect(() => {
    localStorage.setItem("serviceDomain", serviceUrl);
    localStorage.setItem("apiToken", apiToken);
    localStorage.setItem("userEmail", userEmail);
  }, [serviceUrl, apiToken, userEmail]);

  useEffect(() => {
    if (advancedModeEnabled) fetchProjects();
    else setSelectedProjects([]);
  }, [advancedModeEnabled])


  const formatDate = (date, isEnd = false) => {
    if (!date) return "";
  
    const dateValue = new Date(date);
  
    if (isEnd) {
      dateValue.setHours(23, 59, 59, 999);
    } else {
      dateValue.setHours(0, 0, 0, 0);
    }
  
    return dateValue;
  };

  const fetchProjects = async () => {
    let headers: Headers = new Headers();
    headers.set('Content-Type', 'application/json');
    
    let body = JSON.stringify({
      GitlabHost: `${serviceProtocol}://${serviceUrl}`,
      GitlabApiKey: apiToken
    });

    return fetch(`${API_ROUTE}/gitlabreport/fetch-gitlab-projects`, {
      method: "POST",
      headers: headers,
      body
    })
      .then((res) => res.json())
      .then((data) => {
        setProjects(data);
      })
      .catch((err) => {
        console.error(err);
        alert("Error fetching projects");
      });
  }

  const fetchGetFile = async () => {
    let headers: Headers = new Headers();
    headers.set('Content-Type', 'application/json');
    if (selectedService === "gitlab-option") {
      var body = JSON.stringify({
        GitlabHost: `${serviceProtocol}://${serviceUrl}`,
        GitlabApiKey: apiToken,
        DateFrom: formatDate(dateFrom),
        DateTo: formatDate(dateTo, true),
        ReportFileType: reportType,
        ProjectsFilter: selectedProjects
      });
      var endpoint = "/gitlabreport/get-gitlab-report";
    } else {
      var body = JSON.stringify({
        JiraHost: `${serviceProtocol}://${serviceUrl}`,
        JiraUserEmail: userEmail,
        JiraApiKey: apiToken,
        ReportFileType: reportType,
        DateFrom: formatDate(dateFrom),
        DateTo: formatDate(dateTo, true)
      });
      var endpoint = "/jirareport/get-jira-report";
    }
    
    return await fetch(`${API_ROUTE}${endpoint}`, {
      body,
      method: "POST",
      headers: headers
    })
      .then(async response => {
          if (response.status === 200) 
            await response.blob()
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `${selectedService === "gitlab-option" ? "GitLab_" : "Jira_"}TimeTrackReport_${dateFrom}-${dateTo}.${reportType === 1 ? 'xlsx' : 'csv'}`;
                    a.click();
                });
          else if (response.status === 400)
            alert("Error generating report");
          return response;
      });
  };

  const handleSubmit = async () => {
    if (!serviceUrl || !apiToken || !dateFrom || !dateTo) {
      alert("Please fill all fields");
      return;
    }

    setLoading(true);

    try {
      await fetchGetFile();
      
    } catch (e) {
      console.error(e);
      alert("Error generating report");
    } finally {
      setLoading(false);
    }
  };

  const handleProjectToggle = (item) => {
    setSelectedProjects((prev) => {
      if (prev.indexOf(item) !== -1) {
        return prev.filter((i) => i !== item);
      } else {
        return [...prev, item];
      }
    });
  };

  const trySetAdvancedModeEnabled = (checked: boolean) => {
    if (checked && (!serviceUrl || !apiToken)) {
      alert("Please fill Gitlab URL and API key to fetch the projects.");
    }
    else setAdvancedModeEnabled(checked);    
  }
  
  const serviceTypeOptions = [
    {
      id: "gitlab-option",
      label: "GitLab"
    },
    {
      id: "jira-option",
      label: "Jira"
    },
  ];

  const serviceTypeChoosingComponent = () => (
    <div style={{ display: "flex", gap: "40px", margin: "auto" }}>
      {serviceTypeOptions.map((option) => (
        <label
          key={option.id}
          style={{
            cursor: "pointer",
            textAlign: "center",
            border: selectedService === option.id ? "2px solid blue" : "1px solid #ccc",
            padding: "10px",
            borderRadius: "8px",
          }}
        >
          <div className={`${option.id}-logo-img logo-img`}
            style={{ display: "block", marginBottom: "10px", width: "100px" }}
          />

          <input
            type="radio"
            name="image-radio"
            value={option.id}
            checked={selectedService === option.id}
            onChange={() => setSelectedService(option.id)}
          />

          <div>{option.label}</div>
        </label>
      ))}
    </div>
  );


  return (
    <div className="input-form-container">
      {serviceTypeChoosingComponent()}
      <div className="set-service-url-component">
        <select onChange={(e) => setServiceProtocol(e?.target?.value)}>
          <option>https</option>
          <option>http</option>
        </select>
        ://
        <input
          type="text"
          placeholder={`${selectedService === 'gitlab-option' ? 'GitLab' : 'Jira'} URL`}
          value={serviceUrl}
          onChange={(e) => setServiceUrl(e.target.value)}
        />
      </div>
      {selectedService === 'jira-option' && 
        <input
          type="text"
          placeholder="Email"
          value={userEmail}
          onChange={(e) => setUserEmail(e.target.value)}
        />
      }

      <input
        type="password"
        placeholder="API Token"
        value={apiToken}
        onChange={(e) => setApiToken(e.target.value)}
      />

      <div className="set-service-date-filter-component">
        <input
          type="date"
          value={dateFrom}
          onChange={(e) => setDateFrom(e.target.value)}
        />
        <input
          type="date"
          value={dateTo}
          onChange={(e) => setDateTo(e.target.value)}
        />
      </div>
      {selectedService === 'gitlab-option' &&
        <div>
          <label>
            <input 
              type="checkbox" 
              name="advanced-mode-checkbox" 
              checked={advancedModeEnabled}
              onChange={e => trySetAdvancedModeEnabled(e.target.checked)}
            />
            Choose projects
          </label>
          {advancedModeEnabled && (
            <ul>
              {projects.map((item, index) => (
                <li key={index}><input type="checkbox" checked={selectedProjects.indexOf(item) !== -1} onChange={() => handleProjectToggle(item)} />{item}</li>
              ))}
            </ul>
          )}
        </div>
      }

      <div className="split-button">
        <button
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? (
            <div className="spinner"></div>
          ) : (
            "Get Report"
          )}
        </button>
        <select
          value={reportType}
          onChange={(e) => setReportType(Number(e.target.value))}
          disabled={loading}
        >
          <option value={0}>CSV</option>
          <option value={1}>XLSX</option>
        </select>
      </div>
      <p className="about-link">
        <a href="/about">About this tool</a>
      </p>
    </div>
  );
}

export default TimeTrackReporterForm;